<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-row>
				<v-col cols="12" md="6">
					<v-text-field ref="username" class="left-input" v-model="localData.userName" label="نام کاربری" hint="نام کاربری به صورت خودکار پر می شود" persistent-hint disabled />
				</v-col>
				<v-col cols="12" md="6">
					<v-checkbox color="secondary" v-model="localData.isActive" :label="'اکانت فعال'" />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6">
					<v-text-field ref="firstName" v-model="localData.firstName" label="نام بازاریاب*" :error-messages="errorMessages" :rules="[() => !!localData.firstName || 'نام بازاریاب را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field ref="businessName" v-model="localData.businessName" label="نام تجاری*" :error-messages="errorMessages" :rules="[() => !!localData.businessName || 'نام تجاری را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="nationalCode" v-model="localData.nationalCode" label="کد ملی*" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد ملی را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="affiliateCode" v-model="localData.affiliateCode" label="کد بازاریاب*" :error-messages="errorMessages" :rules="[() => !!localData.affiliateCode || 'کد بازاریاب را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="commissionPercent" v-model="localData.commissionPercent" label="درصد پورسانت*" :error-messages="errorMessages" maxlength="6" :rules="[() => localData.commissionPercent >= 0 || 'درصد پورسانت نمی تواند کمتر از 0 باشد', () => localData.commissionPercent <= 100 || 'درصد پورسانت نمی تواند بیشتر از 100 باشد']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="email" v-model="localData.email" label="ایمیل*" :error-messages="errorMessages" :rules="[() => !!localData.email || 'ایمیل را وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6" class="py-0">
					<v-text-field ref="mobile" v-model="localData.mobile" maxlength="11" label="موبایل*" :error-messages="errorMessages" :rules="[() => !!localData.mobile || 'موبایل را وارد کنید']" required />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6">
					<v-text-field v-model="localData.password" persistent-hint :hint="localData.id !== 0 ? 'در صورت خالی بودن پسورد تغییر نخواهد کرد' : 'حداقل 8 کاراکتر'" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => localData.id !== 0 || !!localData.password || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور*" @click:append="show1 = !show1" />
				</v-col>
				<v-col cols="12" md="6">
					<v-text-field v-model="localData.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword" label="تکرار کلمه عبور*" @click:append="show2 = !show2" />
				</v-col>
				<v-col cols="12" md="12" class="py-0">
					<div style="border-radius: 5px;background:#eee;padding: 10px;">
						<div class="text-center secondary--text mb-2">شماره حساب ها</div>
						<v-card v-for="(item, index) in bankAccounts" :key="index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
							<v-row>
								<v-col cols="12" md="5" class="py-0 my-0">
									<v-text-field v-model="item.accountNumber" label="شماره حساب/شبا*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره حساب را وارد کنید']" required />
								</v-col>
								<v-col cols="12" md="3" class="py-0 my-0">
									<v-text-field v-model="item.bank" label="بانک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" required />
								</v-col>
								<v-col cols="12" md="3" class="py-0 my-0">
									<v-text-field v-model="item.branch" label="شعبه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شعبه را وارد کنید']" required />
								</v-col>
								<v-col cols="1" md="1" class="my-0 py-0 d-flex flex-column justify-center">
									<v-btn @click="removeBankAccount(item, index)" class="" x-small icon dark color="pink" title="حذف">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-card>
						<div class="text-center mt-5">
							<v-btn class="mx-auto" color="secondary" dark @click="addBankAccount" small>
								<v-icon dark>
									mdi-plus-circle-outline
								</v-icon>
								شماره حساب جدید
							</v-btn>
						</div>
					</div>
				</v-col>
			</v-row>
			<div class="mt-4">
				<small>لینک بازاریابی و تبلیغات:</small>
				<div v-if="loadingPlans" class="pa-3 text-center success--text">در حال دریافت اطلاعات...</div>
				<div v-else v-for="plan in plans" :key="plan.id" class="pa-2" style="border-bottom: 1px dashed #ddd;">
					<div class="text-center">{{ plan.title }}</div>
					<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
						<v-btn @click="copyToClipborad(plan)" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
							<v-icon color="white">mdi-content-copy</v-icon>
						</v-btn>
						<span style="cursor: pointer;" class="info--text" @click="copyToClipborad(plan)">{{ getLink(plan) }}</span>
					</div>
				</div>
				<div v-if="!loadingPlans">
					<div class="text-center">لینک به صفحه اصلی</div>
					<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
						<v-btn @click="copyToClipborad(plan)" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
							<v-icon color="white">mdi-content-copy</v-icon>
						</v-btn>
						<span style="cursor: pointer;" class="info--text" @click="copyToClipborad()">{{ getLink() }}</span>
					</div>
				</div>
				<div v-if="!loadingPlans">
					<div class="text-center">لینک به صفحه ثبت نام</div>
					<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
						<v-btn @click="copyToClipborad('register')" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
							<v-icon color="white">mdi-content-copy</v-icon>
						</v-btn>
						<span style="cursor: pointer;" class="info--text" @click="copyToClipborad('register')">{{ getLink('register') }}</span>
					</div>
				</div>
			</div>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="$emit('callbck', false)">
					بستن
				</v-btn>
				<v-btn color="blue" :loading="loading" dark type="submit">
					ذخیره
				</v-btn>
			</v-card-actions>
		</v-form>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { get } from 'vuex-pathify'

	export default {
		name: 'ModifyCustomerMarketer',
		components: {
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				loading: false,
				errorMessages: '',
				plans: [],
				claims: [],
				localData: {},
				show1: false,
				show2: false,
				bankAccounts: [],
				loadingPlans: false
			}
		},
		mounted() {
			this.prepareData()
			this.loadPlans()
		},
		computed: {
			...get('siteConfig', [
				'isCloud', 'baseUrl'
			]),
			...get('auth', [
				'getCurrentUser',
			]),
			customerCode() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer) { return `${user.userData.customer.code}` }
				return ''
			}
		},
		methods: {
			loadPlans() {
				this.loadingPlans = true
				api.get('loan/list/' + this.getCurrentUser.userData.customer.code, null)
					.then(response => {
						this.plans = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loadingPlans = false
					})
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.localData.bankAccountsJson = JSON.stringify(this.bankAccounts)
				this.loading = false
				api.post('admin/customermarketer/' + (this.localData.id === 0 ? 'create' : 'edit'), this.localData)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', true)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.loading = false
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: 0 }
				}
				if (!this.data.id) {
					this.data.id = 0
				}
				api.get('admin/customermarketer/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === 0) Object.assign(this.localData, this.data)
							this.bankAccounts = this.localData.bankAccountsJson ? JSON.parse(this.localData.bankAccountsJson) : []
						})
					.catch(err => {
						toast.error(err.message)
					})

			},
			copyToClipborad(plan) {
				const fallbackCopyTextToClipboard = () => {
					var el = document.createElement('textarea')
					el.value = text
					el.setAttribute('readonly', '')
					el.style = {
						position: 'absolute',
						left: '-9999px'
					}
					document.body.appendChild(el)
					el.select()
					document.execCommand('copy')
					document.body.removeChild(el)
					toast.success('لینک به حافظه کپی شد.')
				}
				var text = this.getLink(plan)
				if (!navigator.clipboard) {
					fallbackCopyTextToClipboard(text)
					return
				}
				navigator.clipboard.writeText(text).then(function () {
					toast.success('لینک به حافظه کپی شد.')
				}, function (err) {
					console.error('Async: Could not copy text: ', err)
				})
			},
			getLink(plan) {
				if (!plan)
					return `${this.baseUrl}/cl/plans/${(this.isCloud ? this.customerCode + '/' : '0/')}?mrk=` + this.localData.affiliateCode

				if (plan === 'register')
					return `${this.baseUrl}/register/${(this.isCloud ? this.customerCode + '/' : '0/')}?mrk=` + this.localData.affiliateCode

				return `${this.baseUrl}/cl/plan/${(this.isCloud ? this.customerCode + '/' : '0/')}${plan.code}/?mrk=` + this.localData.affiliateCode
			},
			removeBankAccount(item, index) {
				this.bankAccounts.splice(index, 1)
			},
			addBankAccount() {
				let newItem = {
					accountNumber: '',
					bank: '',
					branch: '',
				}
				this.bankAccounts.push(newItem)
			},
		}
	}
</script>
<style></style>
